/* eslint-disable init-declarations */
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { LoadingFeedback } from 'components/Common/LoadingModal';


interface StreamDisplayProps {
  message: any;
  ticket: boolean;
  pdfMode?: boolean;
}

const ResultsDisplay: React.FC<StreamDisplayProps> = ({
  message,
  ticket,
  pdfMode = false,
}) => {
  // ADD THIS — must be BEFORE return
  const hasFinal =
    Array.isArray(message) &&
    message.some(
      (c: any) => c?.section && c.section !== 'progress' && c?.result?.heading
    );
  return (
    <div
      style={{
        color: 'var(--Text-Main, var(--text-primary))',
        fontSize: '14px',
      }}
    >
      <div
        style={
          pdfMode ?
            { height: 'auto', overflow: 'visible' } :
            ticket ?
            { height: '100%', overflowY: 'auto', minHeight: '560px' } :
            { height: '560px', overflowY: 'auto' }
        }
      >
        {
          ticket ? <LoadingFeedback size='big' /> : (
            message.length === 0 ? (
              <div className='spinner-spacer-top' style={{ textAlign: 'unset' }}>
                <div className=''>Please search in order to receive relevant licensing and control data for your product.</div>
              </div>
            ) : (
              <>
                {message && (
                  message.map((chunk: any, index: React.Key | null | undefined) => {
                    if (hasFinal && chunk?.section === 'progress') {
                      return null;
                    }

                    try {
                      if (chunk?.result?.heading !== 'License Requirement Important Note!' && chunk?.result?.heading === 'Summary of Applicable Controls' && chunk?.result?.heading !== null) {
                        return (
                          <div className='classify-results-card' key={index} style={{ background: '#4895ef26', border: '1px solid var(--Primary-400, #4895ef)', }}>
                            <div className='classify-results-card-text'>
                              <h1 style={{ fontSize: '14px', fontWeight: '600', fontStyle: 'normal' }}>
                                {chunk?.result?.heading}
                              </h1>
                              <ReactMarkdown
                                components={{
                                  p: ({ children }: { children: React.ReactNode }) => (
                                    <p style={{ fontSize: '14px', fontWeight: 400, fontStyle: 'normal', marginBottom: '1em' }}>
                                      {children}
                                    </p>
                                  ),
                                  strong: ({ children }: { children: React.ReactNode }) => (
                                    <strong style={{ fontWeight: 600 }}>
                                      {children}
                                    </strong>
                                  ),
                                  hr: () => (
                                    <hr
                                      style={{
                                        border: 0,
                                        borderTop: '1px solid rgba(255,255,255,0.25)', // tweak color as needed
                                        margin: '14px 0'
                                      }}
                                    />
                                  ),
                                }}
                              >
                                {chunk?.result?.text}
                              </ReactMarkdown>
                            </div>
                          </div>
                        );
                      } else if (chunk?.result?.heading !== 'License Requirement Important Note!' && chunk?.result?.heading !== null) {
                        return (
                          <div className='classify-results-card' key={index}>
                            <div className='classify-results-card-text'>
                              <h1 style={{ fontSize: '14px', fontWeight: '600', fontStyle: 'normal' }}>
                                {chunk?.result?.heading}
                              </h1>
                              <ReactMarkdown
                                components={{
                                  p: ({ children }: { children: React.ReactNode }) => (
                                    <p style={{ fontSize: '14px', fontWeight: 400, fontStyle: 'normal', marginBottom: '1em' }}>
                                      {children}
                                    </p>
                                  ),
                                  strong: ({ children }: { children: React.ReactNode }) => (
                                    <strong style={{ fontWeight: 600 }}>
                                      {children}
                                    </strong>
                                  ),
                                  hr: () => (
                                    <hr
                                      style={{
                                        border: 0,
                                        borderTop: '1px solid rgba(255,255,255,0.25)', // tweak color as needed
                                        margin: '14px 0'
                                      }}
                                    />
                                  ),
                                }}
                              >
                                {chunk?.result?.text}
                              </ReactMarkdown>
                            </div>
                          </div>
                        );
                      }
                    } catch (err) {
                      console.warn('Invalid JSON chunk:', chunk, err);
                      return (
                        <div key={index} className='classify-results-card'>
                          <div className='classify-results-card-text'>
                            <p style={{ color: 'red' }}>⚠️ Invalid response received</p>
                          </div>
                        </div>
                      );
                    }
                  })
                )}

              </>
            )
          )
        }
      </div>

    </div>
  );
};

export default ResultsDisplay;
